<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Processando...</p>
</ngx-spinner>

<section class="d-flex flex-column section-logged-user">
    <div class="d-flex flex-column p-3">
        <div class="p-0 d-flex flex-row-reverse">
            <div style="cursor: pointer;" (click)="fecharModal()">
                <i class="bi bi-x-lg"></i>
            </div>
        </div>
        <div class="d-flex flex-column py-2 px-3">
            <span style="font-size: 1.2rem; text-align: left">
                Confirmação de Autenticidade do Extrato de Processamento EFD
            </span>
        </div>
        <mat-divider></mat-divider>
        <div class="d-flex flex-column py-3 px-3" style="gap: 0.5rem;">
            <span style="font-size: 1rem; font-weight: 600; color: #4f4f4f;">
                Resultado da Consulta
            </span>
        </div>
        <div *ngIf="possuiDadosExtratoValidos" class="d-flex flex-column pb-3" style="gap: 0.9rem;">
            <div class="px-3 py-2 card card-valido">
                <span class="texto-valido"><i class="bi bi-shield-fill-check icone-ativo"></i>
                    Extrato Válido
                </span>
            </div>

            <div *ngIf="statusAtivo" class="px-3 py-2 card card-valido">
                <span class="texto-valido"><i class="bi bi-check-circle-fill icone-ativo"></i>
                    Extrato Ativo
                </span>
            </div>

            <div *ngIf="!statusAtivo" class="px-3 py-2 card card-inativo">
                <span class="texto-inativo"><i class="bi bi-pause-circle-fill icone-inativo"></i>
                    Extrato Inativo
                </span>
            </div>
            
            <div class="px-3 py-2 card">
                <div style="margin-bottom: 0.35rem;"><strong>Número do Extrato:</strong> {{ numeroExtratoFormatado }}</div>
                <div style="margin-bottom: 0.35rem;"><strong>Razão Social:</strong> {{ razaoSocialFormatada }}</div>
                <div style="margin-bottom: 0.35rem;"><strong>Competência:</strong> {{ competenciaFormatada }}</div>
                <div><strong>Situação:</strong> {{ extrato?.situacao }}</div>
            </div>
        </div>
        <div *ngIf="!possuiDadosExtratoValidos" class="d-flex flex-column pb-3 px-3">
            <div class="px-3 py-2 card card-invalido">
                <span class="texto-invalido"><i class="bi bi-x-circle-fill icone-invalido"></i>
                    Extrato Inválido
                </span>
            </div>
        </div>

    </div>
</section>
